import {
  accountsUrl,
  Flag,
  onboardingCompletedUrl,
  settingsLinkedAccountsUrl,
} from "@medbillai/utils";

import { useBoolVariation } from "../flag";
import { useAccountLinkDataStore } from "./accountLinkStore";

export const useAccountLinkExitUrl = (): string => {
  const exitUrl = useAccountLinkDataStore(state => state.exitUrl);
  const isOnboarding = useAccountLinkDataStore(state => state.isOnboarding);
  const coverageTab = useBoolVariation(Flag.COVERAGE_TAB, false);
  if (exitUrl) {
    return exitUrl;
  }
  if (isOnboarding) {
    return onboardingCompletedUrl();
  }
  return coverageTab ? settingsLinkedAccountsUrl() : accountsUrl();
};
